// extracted by mini-css-extract-plugin
export default {"descriptionText":"fNjn1K","resetPasswordInvalidContainer":"oB0ARU"};